import React from 'react';
import { TERMINOS_Y_CONDICIONES_BLOQUES } from '../../constants/terminosYCondiciones';

const TerminosYCondiciones = () => (
  <div className="terminos-contenido">
    {TERMINOS_Y_CONDICIONES_BLOQUES.map((bloque, index) => {
      const key = `${bloque.type}-${index}`;

      if (bloque.type === 'header') {
        return <h4 key={key}>{bloque.text}</h4>;
      }

      if (bloque.type === 'list') {
        return (
          <ul key={key}>
            {bloque.items.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        );
      }

      if (bloque.type === 'disclaimer') {
        return <p key={key} className="terminos-disclaimer">{bloque.text}</p>;
      }

      return <p key={key}>{bloque.text}</p>;
    })}
  </div>
);

export default TerminosYCondiciones;
